module.exports = {
    barrel: {
        symbolsCount: 12,
        symbolNameFormat: "symbol_%d.png",
        blurNameFormat: "blur_%d.png",
        reels: 5,
        rows: 3,
        position: {x: 33, y: 35},
        cellSize: {width: 190, height: 190},
        reelGap: 2,

    },

    symbol_animation_filename_pattern: "symbol_%d",
    lines_filename_pattern: "line_%d",
    frames_filename_pattern: "frame_%d",

    billets_on_filename_pattern: "billet_%d.png",
    billets_off_filename_pattern: "",
    billets_coords: [
        {x:4, y:287}, //0
        {x:4, y:96}, //1
        {x:4, y:475}, //2
        {x:4, y:74}, //3
        {x:4, y:498}, //4
        {x:4, y:140}, //5
        {x:4, y:429}, //6
        {x:4, y:337}, //7
        {x:4, y:237}, //8
        {x:999, y:123}, //9
        {x:999, y:453}, //10
        {x:999, y:234}, //11
        {x:999, y:330}, //12
        {x:999, y:151}, //13
        {x:999, y:424}, //14
        {x:999, y:175}, //15
        {x:999, y:401}, //16
        {x:4, y:118}, //17
        {x:4, y:452}, //18
        {x:999, y:498}, //19
        {x:999, y:77}  //20
    ],
    
    animation_frames_count: [20,14,60,40,75,50,30,57,9,55,15,14],

    animation_speed: [
        0.18,
        0.15,
        0.2,
        0.2,
        0.2,
        0.2,
        0.22,
        0.2,
        0.15,
        0.2,
        0.15,
        0.15
    ],

};


//////////////////
// WEBPACK FOOTER
// ./cfg/slot-config.js
// module id = 13
// module chunks = 0